import Vue from 'vue'
import { Navigation } from '@/config/interfaces'
/* Images below */
import ExitWhite from '@/assets/exit-white.png'
import ExitLightblue from '@/assets/exit-lightblue.png'
import ExitDarkblue from '@/assets/exit-darkblue.png'
import HomeWhite from '@/assets/home-white.png'
import HomeLightblue from '@/assets/home-lightblue.png'
import HomeDarkblue from '@/assets/home-darkblue.png'
import BillWhite from '@/assets/bill-white.png'
import BillLightblue from '@/assets/bill-lightblue.png'
import BillDarkblue from '@/assets/bill-darkblue.png'
import BenefitsWhite from '@/assets/benefits-white.png'
import BenefitsLightblue from '@/assets/benefits-lightblue.png'
import BenefitsDarkblue from '@/assets/benefits-darkblue.png'
import OtherWhite from '@/assets/other-white.png'
import OtherLightblue from '@/assets/other-lightblue.png'
import OtherDarkblue from '@/assets/other-darkblue.png'
import CreditDarkblue from '@/assets/credit-darkblue.png'
import CreditLightgray from '@/assets/credit-lightgray.png'
import CreditWhite from '@/assets/credit-white.png'
import ServicesWhite from '@/assets/services-white.png'
import ServicesLightblue from '@/assets/services-lightblue.png'
import ServicesDarkblue from '@/assets/services-darkblue.png'
import StickyPageWhite from '@/assets/stickypage-white.png'
import StickyPageLightblue from '@/assets/stickypage-lightblue.png'
import StickyPageDarkblue from '@/assets/stickypage-darkblue.png'
import HelpWhite from '@/assets/help-white.png'
import HelpLightblue from '@/assets/help-lightblue.png'
import HelpDarkblue from '@/assets/helo-darkblue.png'
import SettingsWhite from '@/assets/settings-white.png'
import SettingsLightblue from '@/assets/settings-lightblue.png'
import SettingsDarkblue from '@/assets/settings-darkblue.png'
import StoresDarkblue from '@/assets/stores-dark-blue.png'
import StoresLightblue from '@/assets/stores-lightblue.png'
import StoresWhite from '@/assets/stores-white.png'
import GiftDarkblue from '@/assets/GiftDarkblue.png'
import GiftLightblue from '@/assets/GiftLightblue.png'
import GiftWhite from '@/assets/GiftWhite.png'
import { apiRoutes } from '@/helpers/ApiRoutes'

export const NavigationMixin = Vue.extend({
  data: () => ({
    leftViewTitle: ''
  }),

  props: {
    bottomNavigation: {
      type: Object as () => Navigation,
      required: true
    },
    showBottomNav: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    currentNavKey (): string {
      return this.$store.getters.getCurrentNavigationKey
    }
  },

  methods: {
    goToPage (uri: string) {
      this.$emit('loadedPages', false)
      if (uri.includes(apiRoutes.apiLogout)) {
        this.$router.push({ name: 'Logout' })
        return
      }
      this.$axios.get(uri)
        .then(res => {
          this.resetState()
          this.$store.commit('setPageData', res.data.data.pages)
          if (this.$store.getters.getLeftViewState && !this.$props.showBottomNav) {
            this.$router.back()
          }
          this.$emit('loadedPages', true)
          // Set left view title
          setTimeout(() => {
            this.leftViewTitle !== '' && this.$store.dispatch('changeLeftViewTitle', this.leftViewTitle)
          }, 10)
        })
        .catch(() => { /* do nothing */ })
    },
    resetState (): void {
      this.$store.dispatch('toggleViewState', 'main')
      this.$store.dispatch('commitViewContent', '')
      this.$store.dispatch('toggleLeftViewState', false)
      this.$store.dispatch('commitLeftViewContent', '')
    },
    setLeftViewTitle (title: string) {
      this.leftViewTitle = title
    },
    changeNavKey (key: string): void {
      this.$store.dispatch('changeCurrentNavigationKey', key)
    },
    getNavIcon (name: string, type?: string, active?: boolean): string {
      const lightActive = active && !this.$vuetify.theme.dark
      const lightNotSide = !this.$vuetify.theme.dark && type !== 'side'

      switch (name) {
        case 'Pregled':
          return lightActive ? HomeDarkblue : lightNotSide ? HomeLightblue : HomeWhite
        case 'Kredit':
          return lightActive ? CreditDarkblue : lightNotSide ? CreditLightgray : CreditWhite
        case 'Usluge':
          return lightActive ? ServicesDarkblue : lightNotSide ? ServicesLightblue : ServicesWhite
        case 'Benefiti':
        case 'Y.za tebe':
        case 'Y. za tebe':
          return lightActive ? BenefitsDarkblue : lightNotSide ? BenefitsLightblue : BenefitsWhite
        case 'Račun':
          return lightActive ? BillDarkblue : lightNotSide ? BillLightblue : BillWhite
        case 'Logout':
        case 'Izloguj se':
          return lightActive ? ExitDarkblue : lightNotSide ? ExitLightblue : ExitWhite
        case 'Preporuke':
          return lightActive ? StickyPageDarkblue : lightNotSide ? StickyPageLightblue : StickyPageWhite
        case 'Ogrebi i osvoji':
          return lightActive ? GiftDarkblue : lightNotSide ? GiftLightblue : GiftWhite
        case 'Pomoć i podrška':
        case 'Pomoć':
          return lightActive ? HelpDarkblue : lightNotSide ? HelpLightblue : HelpWhite
        case 'Podešavanja':
          return lightActive ? SettingsDarkblue : lightNotSide ? SettingsLightblue : SettingsWhite
        case 'Prodavnice':
          return lightActive ? StoresDarkblue : lightNotSide ? StoresLightblue : StoresWhite
        default:
          return lightActive ? OtherDarkblue : lightNotSide ? OtherLightblue : OtherWhite
      }
    }
  }
})
